import { MgSupplierItemMinimal, PriceSuggestionType, Unit } from '@retail/products/types';
import { PriceSuggestionPriceDTO } from '../dto';

export interface PriceSuggestionPriceProps {
  validFrom: string;
  validTo?: string;
  mgSupplierItem: MgSupplierItemMinimal;
  channel?: string;
  price: number;
  unit: Unit;
  sourceUpdatedAt: string;
  priceSuggestionType: PriceSuggestionType;
  current: boolean;
  expired: boolean;
}

export class PriceSuggestionPrice {
  validFrom: string;
  validTo?: string;
  mgSupplierItem: MgSupplierItemMinimal;
  channel?: string;
  price: number;
  unit: Unit;
  sourceUpdatedAt: string;
  priceSuggestionType: PriceSuggestionType;
  current: boolean;
  expired: boolean;

  constructor({
    validFrom,
    validTo,
    mgSupplierItem,
    channel,
    price,
    unit,
    sourceUpdatedAt,
    priceSuggestionType,
    current,
    expired,
  }: PriceSuggestionPriceProps) {
    this.validFrom = validFrom;
    this.validTo = validTo;
    this.mgSupplierItem = mgSupplierItem;
    this.channel = channel;
    this.price = price;
    this.unit = unit;
    this.sourceUpdatedAt = sourceUpdatedAt;
    this.priceSuggestionType = priceSuggestionType;
    this.current = current;
    this.expired = expired;
  }

  static fromDto = ({
    validFrom,
    validTo,
    mgSupplierItem,
    channel,
    price,
    unit,
    sourceUpdatedAt,
    priceSuggestionType,
    current,
    expired,
  }: PriceSuggestionPriceDTO): PriceSuggestionPrice => {
    return new PriceSuggestionPrice({
      validFrom,
      validTo,
      mgSupplierItem,
      channel,
      price,
      unit: Unit.fromDto(unit),
      sourceUpdatedAt,
      priceSuggestionType,
      current,
      expired,
    });
  };
}
